export default __webpack_public_path__ + "static/fa-solid-900-be9ee23c0c6390141475d519c2c5fb8f.ttf";